// utils/uploads.js
// Les fichiers envoyés (images de questions, avatars...) sont servis par le
// backend sous /uploads. La base de données stocke un chemin relatif
// (ex. "questions/abc.jpg") ; une URL externe (http/https) est laissée telle quelle.
const API_BASE = process.env.REACT_APP_API_URL || "/api";
const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");

export const IMAGE_ACCEPT = "image/jpeg,image/png,image/webp,image/gif";
export const IMAGE_MAX_BYTES = 5 * 1024 * 1024; // 5 Mo (même limite que le backend)

export function resolveUploadUrl(path) {
  if (!path) return "";
  if (/^(https?:|data:|blob:)/i.test(path)) return path;
  return `${API_ORIGIN}/uploads/${String(path).replace(/^\/+/, "")}`;
}

/** Retourne null si le fichier est valide, sinon "type" ou "size". */
export function validateImageFile(file) {
  if (!file) return null;
  if (!IMAGE_ACCEPT.split(",").includes(file.type)) return "type";
  if (file.size > IMAGE_MAX_BYTES) return "size";
  return null;
}
